import dayjs from 'dayjs'
import { useCompetencia } from 'global/components/Selects/SelectCompetencia'
import { tabelaHorarios } from 'service/api'
import { useStore } from 'store'
import CalendarioTabelasHorario from './Calendario/CalendarioTabelasHorario'

export default function TabCalendario() {
    const funcionarioId = useStore(state => state.employeeId)
    const [competencia, setCompetencia] = useCompetencia()

    const competenciaDayjs = dayjs(competencia, 'YYYY-MM')
    const { data = [] } = tabelaHorarios.funcionario.useFetch({
        queryParams: {
            funcionarioId,
            dataInicial: competenciaDayjs
                .startOf('month')
                .subtract(2, 'week')
                .format('YYYY-MM-DD'),
            dataFinal: competenciaDayjs
                .endOf('month')
                .add(2, 'week')
                .format('YYYY-MM-DD'),
        },
    })

    return (
        <CalendarioTabelasHorario
            value={competencia}
            tabelas={data}
            onChange={setCompetencia}
        />
    )
}
